import { useEffect, useState } from 'react'

import { Flex } from 'antd'
import {
  CAN_REDO_COMMAND,
  COMMAND_PRIORITY_CRITICAL,
  REDO_COMMAND
} from 'lexical'

import { WpsRedoIcon } from '@eastcoal/icon/WpsRedoIcon'

import { useEditor } from '../../hooks/useEditor'
import { SHORTCUTS } from '../../plugins/ShortcutsPlugin/shortcuts'
import { MenuButton } from '../../ui/MenuButton'

export const RedoButton = () => {
  const [canRedo, setCanRedo] = useState(false)

  const editor = useEditor()

  useEffect(() => {
    return editor.registerCommand<boolean>(
      CAN_REDO_COMMAND,
      payload => {
        setCanRedo(payload)
        return false
      },
      COMMAND_PRIORITY_CRITICAL
    )
  }, [editor])

  const handleRedo = () => {
    editor.dispatchCommand(REDO_COMMAND, undefined)
  }

  return (
    <MenuButton
      disabled={!canRedo}
      tooltip={
        <Flex vertical align='center'>
          <span>恢复</span>
          <span>{SHORTCUTS.REDO}</span>
        </Flex>
      }
      onClick={handleRedo}
    >
      <WpsRedoIcon />
    </MenuButton>
  )
}
